import React, { useContext, useMemo } from "react";
import { MapContainer, TileLayer, CircleMarker, Tooltip, Polyline } from "react-leaflet";
import { ContentContext } from "../contexts/ContentContext";
import "leaflet/dist/leaflet.css";

const LOCATIONS = {
    Kyrgyzstan:     { coords: [42.8746, 74.5698], type: "hq" },
    "Saudi Arabia": { coords: [24.7136, 46.6753], type: "primary" },
    Russia:         { coords: [55.7558, 37.6173], type: "primary" },
    Malaysia:       { coords: [3.1390, 101.6869], type: "primary" },
    "EAEU Countries": { coords: [49.8, 73.1], type: "region" },
    GCC:            { coords: [25.2048, 55.2708], type: "region" },
    "Кыргызстан":   { coords: [42.8746, 74.5698], type: "hq" },
    "Саудовская Аравия": { coords: [24.7136, 46.6753], type: "primary" },
    "Россия":       { coords: [55.7558, 37.6173], type: "primary" },
    "Малайзия":     { coords: [3.1390, 101.6869], type: "primary" },
    "Страны ЕАЭС":  { coords: [49.8, 73.1], type: "region" },
    "قيرغيزستان":   { coords: [42.8746, 74.5698], type: "hq" },
    "المملكة العربية السعودية": { coords: [24.7136, 46.6753], type: "primary" },
    "روسيا":        { coords: [55.7558, 37.6173], type: "primary" },
    "ماليزيا":      { coords: [3.1390, 101.6869], type: "primary" },
    "دول الاتحاد الأوراسي": { coords: [49.8, 73.1], type: "region" },
    "الخليج":       { coords: [25.2048, 55.2708], type: "region" },
};

const STYLES = {
    hq:      { radius: 10, color: "#D4A017", fillColor: "#D4A017", fillOpacity: 0.9, weight: 3 },
    primary: { radius: 8,  color: "#0B1F3A", fillColor: "#0B1F3A", fillOpacity: 0.8, weight: 2 },
    region:  { radius: 7,  color: "#4A6FA5", fillColor: "#4A6FA5", fillOpacity: 0.6, weight: 2 },
};

export default function FootprintMap() {
    const { data } = useContext(ContentContext);

    const points = useMemo(
        () =>
            data.geography.regions
                .map((r) => {
                    const loc = LOCATIONS[r.name];
                    return loc ? { ...r, ...loc } : null;
                })
                .filter(Boolean),
        [data.geography.regions]
    );

    const hq = points.find((p) => p.type === "hq");
    const corridors = hq
        ? points.filter((p) => p.type !== "hq").map((p) => [hq.coords, p.coords])
        : [];

    return (
        <div className="relative rounded-2xl overflow-hidden border border-navy-100 shadow-card">
            <MapContainer
                center={[35, 60]}
                zoom={3}
                minZoom={2}
                scrollWheelZoom={false}
                style={{ height: "480px", width: "100%", background: "#f4f6fa" }}
                worldCopyJump
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {corridors.map((line, i) => (
                    <Polyline
                        key={i}
                        positions={line}
                        pathOptions={{ color: "#D4A017", weight: 1.5, opacity: 0.5, dashArray: "6 8" }}
                    />
                ))}
                {points.map((p, i) => (
                    <CircleMarker key={i} center={p.coords} pathOptions={STYLES[p.type]}>
                        <Tooltip direction="top" offset={[0, -8]} opacity={1} permanent={false}>
                            <div className="text-xs">
                                <div className="font-bold text-navy-900">{p.name}</div>
                                <div className="text-navy-600">{p.role}</div>
                            </div>
                        </Tooltip>
                    </CircleMarker>
                ))}
            </MapContainer>
            <div className="absolute bottom-3 end-3 bg-white/95 backdrop-blur rounded-lg px-3 py-2 shadow-soft border border-navy-100 z-[400] text-[11px] space-y-1">
                <div className="flex items-center gap-2">
                    <span className="w-3 h-3 rounded-full bg-gold-500 ring-2 ring-gold-500/30"></span>
                    <span className="text-navy-800 font-medium">Headquarters</span>
                </div>
                <div className="flex items-center gap-2">
                    <span className="w-3 h-3 rounded-full bg-navy-900"></span>
                    <span className="text-navy-800 font-medium">Key Market</span>
                </div>
                <div className="flex items-center gap-2">
                    <span className="w-3 h-3 rounded-full bg-navy-400"></span>
                    <span className="text-navy-800 font-medium">Region</span>
                </div>
            </div>
        </div>
    );
}
